import createCachedSelector from 're-reselect'

import extractXValuesFromJoinedDataSet from './extractXValuesFromJoinedDataSet'
import fullPropsSetCacheKey from './cacheKeys/fullPropsSetCacheKey'
import selectDataSets from './selectDataSets'

export default createCachedSelector(selectDataSets, dataSets => {
  return extractXValuesFromJoinedDataSet(dataSets)
})(fullPropsSetCacheKey)
